import { groupOverviewActionTypes } from './Constants';
import { groupDetailsActionTypes } from '../groupDetails/Constants';

const initialState = {
	loading: true,
	activeGroups: null,
	invitedGroups: [],
	requestedGroups: [],
	requestedGroupsCount: 0,
	invitedGroupsCount: 0,
	isConfirmationModalOpen: false,
	createGroupModal: {
		loading: false,
		open: false,
	},
	createGroupInfo: {
		edit: false,
		groupId: null,
		title: null,
		subject: null,
		educationType: null,
		level: null,
		grade: null,
		school: null,
		shared: true,
		auto_join: true,
		type: null,
	},
	educationTypes: [],
	availableSubjects: [],
	levels: [],
	grades: [],
	schools: [],
	institutes: [],
	schoolsLoading: false,
	imageUrl: null,
	userData: {},
	educationTypesLoading: true,
};

export default function groupOverviewReducer(state = initialState, action) {
	const { type, payload } = action;
	const {
		activeGroups,
		invitedGroups,
		requestedGroups,
		status,
		groupId,
		open,
		educationTypes,
		schools,
		createGroupInfo,
		subjects,
		userData,
		options,
		institutes,
		subjectId,
		isFromAddListModal,
	} = payload || {};

	switch (type) {
		case groupOverviewActionTypes.GET_ACTIVE_GROUPS_REQUEST:
		case groupOverviewActionTypes.GET_INVITED_GROUPS_REQUEST:
		case groupOverviewActionTypes.GET_REQUESTED_GROUPS_REQUEST:
			return {
				...state,
				loading: true,
			};

		case groupOverviewActionTypes.GET_ACTIVE_GROUPS_SUCCESS:
			return {
				...state,
				loading: false,
				activeGroups,
				requestedGroupsCount: activeGroups.requested_groups_count,
				invitedGroupsCount: activeGroups.invited_groups_count,
			};

		case groupOverviewActionTypes.GET_INVITED_GROUPS_SUCCESS:
			return {
				...state,
				loading: false,
				invitedGroups: invitedGroups.groups,
				requestedGroupsCount: invitedGroups.requested_groups_count,
				invitedGroupsCount: invitedGroups.invited_groups_count,
			};

		case groupOverviewActionTypes.GET_REQUESTED_GROUPS_SUCCESS:
			return {
				...state,
				loading: false,
				requestedGroups: requestedGroups.groups,
				requestedGroupsCount: requestedGroups.requested_groups_count,
				invitedGroupsCount: requestedGroups.invited_groups_count,
			};

		case groupOverviewActionTypes.HANDLE_CONFIRMATION_MODAL:
			return {
				...state,
				isConfirmationModalOpen: status,
			};

		case groupOverviewActionTypes.DELETE_GROUP_SUCCESS:
		case groupOverviewActionTypes.LEAVE_GROUP_SUCCESS:
			return {
				...state,
				isConfirmationModalOpen: false,
				activeGroups: state.activeGroups && {
					groups: state.activeGroups?.groups?.filter((group) => group.id !== groupId),
					license_groups: state.activeGroups?.license_groups?.filter(
						(group) => group.id !== groupId,
					),
				},
			};

		case groupOverviewActionTypes.ACCEPT_INVITATION_SUCCESS:
		case groupOverviewActionTypes.DECLINE_INVITATION_SUCCESS:
			return {
				...state,
				invitedGroupsCount: state.invitedGroupsCount - 1,
				isConfirmationModalOpen: false,
				invitedGroups: state.invitedGroups.filter((group) => group.id !== groupId),
			};

		case groupOverviewActionTypes.RETRACT_INVITATION_SUCCESS:
			return {
				...state,
				isConfirmationModalOpen: false,
				requestedGroups: state.requestedGroups.filter((group) => group.id !== groupId),
				requestedGroupsCount: state.requestedGroupsCount - 1,
			};

		case groupDetailsActionTypes.JOIN_GROUP_SUCCESS:
			return {
				...state,
				loading: false,
				requestedGroupsCount: state.requestedGroupsCount + 1,
			};

		case groupOverviewActionTypes.TOGGLE_CREATE_GROUP_MODAL:
			return {
				...state,
				loading: false,
				createGroupModal: {
					loading: false,
					open,
					subjectId,
					isFromAddListModal,
				},
			};

		case groupOverviewActionTypes.GET_EDUCATION_TYPES_SUCCESS:
			const { educationType, level } = state.createGroupInfo;
			const levels =
				(educationType &&
					educationType.id &&
					educationTypes.education_types.filter((item) => item.id === educationType.id)[0]
						.options) ||
				[];

			const grades =
				(levels &&
					level &&
					level.school_track_id &&
					!!levels.length &&
					levels.filter((item) => item.school_track_id === level.school_track_id)[0]
						.options) ||
				[];

			return {
				...state,
				educationTypes: educationTypes.education_types,
				levels,
				grades,
				educationTypesLoading: false,
			};

		case groupOverviewActionTypes.GET_EDUCATION_TYPES_ERROR:
			return {
				...state,
				loading: false,
				educationTypesLoading: false,
			};

		case groupOverviewActionTypes.GET_SCHOOL_REQUEST:
			return {
				...state,
				schoolsLoading: true,
			};

		case groupOverviewActionTypes.GET_SCHOOL_SUCCESS:
			return {
				...state,
				schoolsLoading: false,
				schools,
			};

		case groupOverviewActionTypes.SET_GROUP_INFO:
			return {
				...state,
				...options,
				createGroupInfo,
			};

		case groupOverviewActionTypes.GET_AVAILABLE_SUBJECTS_SUCCESS:
			return {
				...state,
				availableSubjects: subjects,
			};

		case groupOverviewActionTypes.GET_SCHOOL_ERROR:
			return {
				...state,
				schoolsLoading: false,
			};

		case groupOverviewActionTypes.GET_ACTIVE_GROUPS_ERROR:
		case groupOverviewActionTypes.GET_INVITED_GROUPS_ERROR:
		case groupOverviewActionTypes.GET_REQUESTED_GROUPS_ERROR:
		case groupOverviewActionTypes.ACCEPT_INVITATION_ERROR:
		case groupOverviewActionTypes.DELETE_GROUP_ERROR:
			return {
				...state,
				loading: false,
			};

		case groupOverviewActionTypes.GET_USER_DETAILS_SUCCESS:
			return {
				...state,
				userData,
			};

		case groupOverviewActionTypes.CREATE_GROUP_REQUEST:
			return {
				...state,
				createGroupModal: {
					...state.createGroupModal,
					loading: true,
				},
			};

		case groupOverviewActionTypes.CREATE_GROUP_ERROR:
			return {
				...state,
				createGroupModal: {
					...state.createGroupModal,
					loading: false,
				},
			};

		case groupOverviewActionTypes.GET_EDUCATION_TYPES_REQUEST:
		case groupOverviewActionTypes.GET_INSTITUTES_REQUEST:
			return {
				...state,
				educationTypesLoading: true,
			};

		case groupOverviewActionTypes.GET_INSTITUTES_SUCCESS:
			return {
				...state,
				institutes,
				educationTypesLoading: false,
			};
		case groupOverviewActionTypes.GET_INSTITUTES_ERROR:
			return {
				...state,
				educationTypesLoading: false,
			};

		case groupOverviewActionTypes.CLEAN_CREATE_GROUP_MODAL_STATE:
			return {
				...state,
				createGroupInfo: {
					edit: false,
					groupId: null,
					title: null,
					subject: null,
					educationType: null,
					level: null,
					grade: null,
					school: null,
					shared: true,
					auto_join: true,
				},
				educationTypes: [],
				availableSubjects: [],
				levels: [],
				grades: [],
				schools: [],
				institutes: [],
				schoolsLoading: false,
				educationTypesLoading: true,
				imageUrl: null,
				userData: {},
			};

		case groupOverviewActionTypes.CLEAN_GROUP_OVERVIEW_STATE:
			return initialState;

		default:
			return state;
	}
}
